module.exports = __webpack_public_path__ + "fonts/fa-solid-900.07c3313.ttf";